import * as stylex from "@stylexjs/stylex";
import React from "react";
import { colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
const styles = {
    annotationBandLabel: {
        kDwRjp: "x13ylgtg",
        kCrYw0: "x1x0jnz8",
        kjVXCG: "xqvyd8v",
        kfJifR: "xnpr05h",
        kU5bRw: "x5lxx2x",
        kJdQPc: "x1bivah8",
        $$css: true
    },
    annotationText: {
        k63SB2: "x117nqv4",
        kDwRjp: "xjqwmh7",
        kCrYw0: "x1x0jnz8",
        kjVXCG: "xqvyd8v",
        kfJifR: "xnpr05h",
        kU5bRw: "x5lxx2x",
        kJdQPc: "x1bivah8",
        $$css: true
    }
};
function YAnnotations_({ annotations, width, yScale, yFormat }) {
    return <>
      {annotations.map((annotation, i)=>{
        switch(annotation.type){
            case "line":
                {
                    return <g key={`annotation-${i}`} transform={`translate(0,${yScale(annotation.value)})`}>
                <rect x={0} y={-1.5} height={3} width={width} className="xjqwmh7 xqvyd8v xnpr05h"/>
                {annotation.label && <>
                    <text x={0} textAnchor="start" dy={annotation.dy || "-0.4em"} {...stylex.props(typography.meta, styles.annotationText)}>
                      {yFormat(annotation.value, false)}
                    </text>
                    <text x={width} textAnchor="end" dy={annotation.dy || "-0.4em"} {...stylex.props(typography.meta, styles.annotationText)}>
                      {annotation.label}
                    </text>
                  </>}
              </g>;
                }
            case "band":
                {
                    const [y1 = 0, y2 = 0] = annotation.range.map(yScale);
                    return <g key={`annotation-${i}`} transform={`translate(0,${y2})`}>
                <rect x={0} y={0} height={y1 - y2} width={width} className="x42x0ya x1wwuglj"/>
                <text x={0} textAnchor="start" dy={annotation.dy || "-0.4em"} {...stylex.props(typography.axis, styles.annotationBandLabel)}>
                  {annotation.label}
                </text>
              </g>;
                }
            default:
                return null;
        }
    })}
    </>;
}
export const YAnnotations = React.memo(YAnnotations_);
